import React, {useEffect, useState} from 'react';
import styles from "./Nasa.module.css";

const Nasa = () => {

const getDate = async () => {

    const date = document.getElementById("date").value
    const key = "D9GIJ6MxFnCTbRZt6NP9sPJYvXljNi2sQIZQ0vix";
    const url = `https://api.nasa.gov/planetary/apod?api_key=${key}&date=${date}`;

    const respode = await fetch(url);
    const dados = await respode.json();
    return update(dados);
}

const update = (dados) => {

    document.getElementById("pic_date").innerHTML = dados.date;
    document.getElementById("title").innerHTML = dados.title;
    document.getElementById("apod_pic").src = dados.url;
    document.getElementById("caption").innerHTML = dados.explanation;
    return dados; 
}

useEffect(() => {
   getDate();
   AtivarLoading();
},[]);

const [isLoading, setLoading] = useState(null);

function AtivarLoading() {
  setLoading(true);
  setTimeout(() => {
    setLoading(false);
  },500);
}

  return (
    <>
      <div className={styles.container}>
        <div className={styles.boxCard}>

          {/* ================= TOPO SEO ================= */}
          <h2>Foto Astronômica do Dia (NASA)</h2>
          <p className={styles.classPnasa}>
            Explore imagens incríveis do universo com a ferramenta oficial da NASA. 
            Descubra fotos espaciais por data e veja como era o cosmos em qualquer dia da história.
          </p>

          <div className={styles.infoBox}>
            <h3>🌌 Como funciona?</h3>
            <p>
              Esta ferramenta utiliza a API oficial da NASA (APOD - Astronomy Picture of the Day) 
              para exibir imagens reais do espaço acompanhadas de explicações detalhadas.
            </p>

            <h3>🚀 O que você pode fazer:</h3>
            <ul>
              <li>Ver imagens reais do espaço por data</li>
              <li>Descobrir curiosidades sobre o universo</li>
              <li>Explorar fotos históricas da NASA</li>
              <li>Encontrar a imagem do dia do seu nascimento</li>
            </ul>

            <p className={styles.alerta}>
              ⚠️ <strong>Atenção:</strong> A busca por data está disponível a partir de 16/06/1995, quando o projeto APOD (Astronomy Picture of the Day) da NASA foi iniciado.  
              Datas anteriores a esse período não possuem imagens disponíveis na base de dados.
            </p>
          </div>

          {/* ================= BUSCA ================= */}
          <div  className={styles.boxSerch} id="serch">
            <input type="date" id="date"/>
            <button onClick={getDate}>Buscar</button>
          </div>

        {isLoading &&
              <div className={styles.imagesContainerLoading}>
                <div className={styles.loading}><div className={styles.loadingEsfera}></div></div>
              </div> 
        } 

          {/* ================= RESULTADO ================= */}
          <div className={styles.cardSearch}>
            <em className={styles.date} id="pic_date"/>
            <h3 className={styles.title} id="title"/>
            <div>
                <img src="" alt="Imagem astronômica da NASA" id="apod_pic" className={styles.img}/>
            </div>
            <p className={styles.text} id="caption"/>   
          </div>

          {/* ================= FINAL SEO ================= */}
          <div className={styles.infoBox}>
            <h3>🔭 Sobre as imagens</h3>
            <p>
              Todas as imagens são fornecidas pela NASA e podem incluir galáxias, nebulosas, planetas, 
              estrelas e fenômenos espaciais raros. Cada imagem vem com uma explicação oficial para 
              ajudar você a entender melhor o universo.
            </p>

            <h3>💡 Dica</h3>
            <p>
              Tente buscar datas antigas para encontrar imagens raras e surpreendentes do espaço.
            </p>
          </div>

          <div id='BoxAfiliados'></div>

        </div>
      </div>
    </>
  )
}

export default Nasa;